import React from 'react';

import styles from 'src/app/surveys/views/new-survey-design/NewSurveyDesign.module.scss';
import SampleGroups from './components/sample-groups/SampleGroups';
import HabitatAssayTypes from './components/habitat-assay-types/HabitatAssayTypes';

export const SurveyDesignAims = () => {
    return (
        <div className={styles.formView}>
            <div className={styles.formViewTitle}>Project target</div>
            <SampleGroups />
            <HabitatAssayTypes />
        </div>
    );
};

export default SurveyDesignAims;
